// One launch radius, in miles. The waitlist card shows only where no café is
// this close, and the launch sweep counts cafés this close. Keeping both on
// the same number is what makes every Founding vote a before launch vote.
// A byte identical copy lives in supabase/functions/_shared/ (a test keeps them equal).
export const CITY_LAUNCH_RADIUS_MILES = 10;
